import React from 'react';
import { FileText, Camera, PenTool, BarChart, Euro } from 'lucide-react';

export const SoFunktioniertPartner = () => {
  const steps = [
    {
      icon: FileText,
      title: 'Fall anlegen',
      description: 'Erstelle einen neuen Fall im Portal mit den Basisdaten deines Kunden',
      role: 'partner'
    },
    {
      icon: Camera,
      title: 'Foto-Dokumentation',
      description: 'Lade die Pflichtfotos direkt im Portal hoch – mit Checkliste als Hilfe',
      role: 'partner'
    },
    {
      icon: PenTool,
      title: 'Digitale Unterschrift',
      description: 'Dein Kunde unterschreibt die Abtretungserklärung mobil oder am Tablet',
      role: 'partner'
    },
    {
      icon: BarChart,
      title: 'Gutachten & Kalkulation',
      description: 'Wir erstellen das Gutachten und die Schadenskalkulation professionell',
      role: 'wir'
    },
    {
      icon: Euro,
      title: 'Status & Provision',
      description: 'Du siehst den Bearbeitungsstatus live und erhältst deine Provision',
      role: 'partner'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            So funktioniert die Zusammenarbeit
          </h2>
          <p className="text-lg text-gray-600">
            Einfacher Ablauf, klare Prozesse
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-5 gap-8 mb-16">
          {steps.map((step, index) => {
            const Icon = step.icon;
            
            return (
              <div key={index} className="relative">
                <div className="text-center">
                  <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-brand-green/20">
                    <Icon className="h-8 w-8 text-brand-green" />
                  </div>
                  <div className="absolute top-8 left-1/2 w-full h-0.5 bg-gray-200 -z-10 hidden md:block" 
                       style={{display: index === steps.length - 1 ? 'none' : 'block'}} />
                  
                  <div className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-xs font-semibold rounded-full mb-3">
                    Schritt {index + 1}
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Verantwortlichkeiten */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-brand-green/5 to-brand-blue/5 rounded-2xl p-8 border border-brand-green/20">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Als Partner übernimmst du:</h3>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">✓</span>
                <span>Kunden-Kontakt und Terminabstimmung</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">✓</span>
                <span>Foto-Upload und Dokumentation</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">✓</span>
                <span>Unterschriften digital einholen</span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Wir übernehmen für dich:</h3>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">✓</span>
                <span>Professionelle Gutachten-Erstellung</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">✓</span>
                <span>Schadenskalkulation und Bewertung</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">✓</span>
                <span>Kommunikation mit Versicherungen</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-green mt-1">✓</span>
                <span>Provision-Abrechnung</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
